import * as React from 'react';
import { Container, Form, Radio, Button } from 'semantic-ui-react';
import ReCAPTCHA from 'react-google-recaptcha';
import * as Sentry from '@sentry/browser';
import { recaptchaSize } from '../../helpers/common';
import FormsPostcodeSearch from './FormsPostcodeSearch';
import { submitFormData } from '../../helpers/form-api';

const recaptchaKey = process.env.GATSBY_GOOGLE_RECAPTCHA_KEY || '';

class HighLoadForm extends React.Component {
  initialFormData = {
    network_distributor: '',
    first_name: '',
    last_name: '',
    position: '',
    company: '',
    company_address: '',
    phone: '',
    mobile_phone: '',
    fax: '',
    email: '',
    load_type: '',
    load_height: '',
    starting_point: '',
    destination: '',
    drivers_name: '',
    drivers_contact_no: '',
    number_of_vehicles: '',
    number_of_loads: '',
    proposed_date_of_travel: '',
    details_of_proposed_route: '',
    comments: '',
  };

  state = {
    error: null,
    success: null,
    submitting: false,
    formData: {
      ...this.initialFormData,
    },
  };

  recaptchaRef = React.createRef();

  handleCaptcha = (value) => {
    this.setState({ captcha: value });
  };

  handleInputChange = (event) => {
    const target = event.currentTarget;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  handleSelectChange = (event, { name, value }) => {
    this.setState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  handleSubmit = async () => {
    try {
      this.setState({ success: null, error: null, submitting: true });

      if (this.state.captcha) {
        const formData = {
          ...this.state.formData,
          captchaResponse: this.state.captcha,
        };
        const response = await submitFormData('high_load', formData);

        if (response.status !== 200) {
          this.setState({
            success: null,
            error: response.message,
            submitting: false,
            captcha: null,
          });
        } else {
          this.setState({
            success:
              'Thank you for your enquiry.  A team member will respond within 2 working days.',
            error: null,
            submitting: false,
            formData: { ...this.initialFormData },
            captcha: null,
          });
        }

        if (this.recaptchaRef.current) {
          this.recaptchaRef.current.reset();
        }
      } else {
        this.setState({
          success: null,
          error: 'Please tick ReCAPTCHA',
          submitting: false,
        });
      }
    } catch (err) {
      console.error(err);
      Sentry.captureException(err);
      this.setState({ error: 'Error', success: null, submitting: false });
    }
  };

  submitText = () => {
    if (this.state.submitting) {
      return 'Submitting...';
    } else if (this.state.success) {
      return 'Submitted';
    }
    return 'Submit';
  };

  render() {
    const {
      first_name,
      last_name,
      position,
      company,
      company_address,
      phone,
      mobile_phone,
      fax,
      email,
      load_type,
      load_height,
      starting_point,
      destination,
      drivers_name,
      drivers_contact_no,
      number_of_vehicles,
      number_of_loads,
      proposed_date_of_travel,
      network_distributor,
      details_of_proposed_route,
      comments,
    } = this.state.formData;

    return (
      <section>
        <Container>
          <div className="grid-wrapper">
            <div className="form-container">
              <FormsPostcodeSearch />

              <Form onSubmit={this.handleSubmit}>
                <h4>Network distributor</h4>
                <Form.Field>
                  <p>
                    In which network are you applying for an evaluation of a
                    high load transportation?
                    {/* <span className="form-required">*</span> temporarily not required due to hidden radio button field*/}
                  </p>
                  <Radio
                    label="CitiPower network"
                    name="network_distributor"
                    checked={network_distributor === 'citipower'}
                    onChange={this.handleSelectChange}
                    value="citipower"
                    required
                    id="form-network-citipower"
                  />
                </Form.Field>
                <Form.Field>
                  <Radio
                    label="Powercor network"
                    name="network_distributor"
                    checked={network_distributor === 'powercor'}
                    onChange={this.handleSelectChange}
                    value="powercor"
                    id="form-network-powercor"
                  />
                </Form.Field>

                <h4>Application details</h4>
                <Form.Input
                  label="First name"
                  required
                  name="first_name"
                  type="text"
                  value={first_name}
                  onChange={this.handleInputChange}
                  id="form-first-name"
                />

                <Form.Input
                  label="Last name"
                  required
                  type="text"
                  name="last_name"
                  value={last_name}
                  onChange={this.handleInputChange}
                  id="form-last-name"
                />

                <Form.Input
                  label="Position"
                  required
                  type="text"
                  name="position"
                  value={position}
                  onChange={this.handleInputChange}
                  id="form-position"
                />

                <Form.Input
                  label="Company name"
                  required
                  type="text"
                  name="company"
                  value={company}
                  onChange={this.handleInputChange}
                  id="form-company"
                />

                <Form.Input
                  label="Company address"
                  required
                  type="text"
                  name="company_address"
                  value={company_address}
                  onChange={this.handleInputChange}
                  id="form-company-address"
                />

                <Form.Field>
                  <Form.Input
                    label="Phone Number"
                    type="phone"
                    required
                    name="phone"
                    value={phone}
                    onChange={this.handleInputChange}
                    id="form-phone"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Mobile Phone"
                    type="phone"
                    name="mobile_phone"
                    value={mobile_phone}
                    onChange={this.handleInputChange}
                    id="form-mobile-phone"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Fax Number"
                    type="phone"
                    name="fax"
                    value={fax}
                    onChange={this.handleInputChange}
                    id="form-fax"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Email Address"
                    type="email"
                    required
                    name="email"
                    value={email}
                    onChange={this.handleInputChange}
                    id="form-email"
                  />
                </Form.Field>

                <h4>Transport Details</h4>
                <Form.Field>
                  <Form.Input
                    label="Load Type"
                    type="text"
                    required
                    name="load_type"
                    value={load_type}
                    onChange={this.handleInputChange}
                    id="form-load-type"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Load Height"
                    type="text"
                    required
                    name="load_height"
                    value={load_height}
                    onChange={this.handleInputChange}
                    id="form-load-height"
                  />
                </Form.Field>

                <Form.Input
                  label="Starting Point"
                  type="text"
                  required
                  name="starting_point"
                  value={starting_point}
                  onChange={this.handleInputChange}
                  id="form-starting-point"
                />

                <Form.Input
                  label="Destination"
                  type="text"
                  required
                  name="destination"
                  value={destination}
                  onChange={this.handleInputChange}
                  id="form-destination"
                />

                <Form.Field>
                  <Form.Input
                    label="Drivers Name"
                    type="text"
                    required
                    name="drivers_name"
                    value={drivers_name}
                    onChange={this.handleInputChange}
                    id="form-drivers-name"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Drivers Contact Number"
                    type="phone"
                    required
                    name="drivers_contact_no"
                    value={drivers_contact_no}
                    onChange={this.handleInputChange}
                    id="form-drivers-contact-no"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Number of Vehicles"
                    type="text"
                    required
                    name="number_of_vehicles"
                    value={number_of_vehicles}
                    onChange={this.handleInputChange}
                    id="form-number-of-vechicles"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    label="Number Of Loads"
                    type="number"
                    required
                    name="number_of_loads"
                    value={number_of_loads}
                    onChange={this.handleInputChange}
                    id="form-number-of-loads"
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Input
                    className="calendar-icon"
                    label="Proposed Date of Travel"
                    type="date"
                    required
                    name="proposed_date_of_travel"
                    value={proposed_date_of_travel}
                    onChange={this.handleInputChange}
                    id="form-proposed-date-of-travel"
                  />
                </Form.Field>

                <h4>Details of proposed route</h4>
                <Form.TextArea
                  label="Details of proposed route"
                  name="details_of_proposed_route"
                  value={details_of_proposed_route}
                  onChange={this.handleInputChange}
                  id="form-details-of-proposed-route"
                />

                <h4>Additional comments</h4>
                <Form.TextArea
                  label="Please add any additional comments you believe will assist CitiPower or Powercor to assess your application below:"
                  name="comments"
                  value={comments}
                  onChange={this.handleInputChange}
                  id="form-comments"
                />

                <ReCAPTCHA
                  ref={this.recaptchaRef}
                  sitekey={recaptchaKey}
                  onChange={this.handleCaptcha}
                  size={recaptchaSize()}
                />

                <Button
                  className="form--submit-btn"
                  disabled={this.state.submitting}
                  loading={this.state.submitting}
                >
                  {this.submitText()}
                </Button>

                {this.state.success ? (
                  <div className="success-message">{this.state.success}</div>
                ) : null}
                {this.state.error ? (
                  <div className="error-message">{this.state.error}</div>
                ) : null}
              </Form>
            </div>
          </div>
        </Container>
      </section>
    );
  }
}

export default HighLoadForm;
